import { DeanteData } from "../Universal/API/Context-API/AppProvider";

export const chars_to_show: {
  key: (keyof DeanteData) | (keyof DeanteData)[];
  label: string;
}[] = [
  { key: "col", label: "Коллекция:" },
  { key: "art", label: "Артикул:" },
  // { key: ["name"], label: "Название:" },
  { key: ["color1"], label: "Цвет:" },
  { key: "poverh", label: "Поверхность:" },
  { key: "material", label: "Материал:" },
  { key: "price", label: "Цена:" },
  { key: "ostatki", label: "В наличии" },
];
